export default {
	materialUnavailable: {
		singleLine1: "The material of this article is not available.",
		singleLine2: "Click here to change the material.",
		assemblyLine1:
			"The material of one or more individual articles of this assembly is not available.",
		assemblyLine2: "Click here to display the individual articles.",
	},
	cad: {
		tooltipLine1: "Opens the CAD model in the browser.",
		tooltipLine2:
			"In Blexon's integrated CAD editor, you can add / edit threads, countersinks, engravings, weld seams, etc.",
		tooltipLine3: "You can also check dimensions, view messages and fix causes of errors.",
	},
	features: {
		label: "Treatments",
		basePrimed: "- primed",
		engraving: "Engraving",
	},
	info: {
		articleNumberLabel: "Article no.:",
		blexonNumberLabel: "Blexon no.:",
		materialTypeLabel: "Material:",
		thicknessLabel: "Thickness:",
		topSideLabel: "Top side",
		bottomSideLabel: "Bottom side",
		quantityInAssemblyLabel: "Quantity in assembly:",
		dimensionsLabel: "LxWxH:",
		weightLabel: "Weight:",
		deburringLabel: "Deburring:",
		powderCoatingLabel: "Powder coating:",
		zincCoatingLabel: "Zinc coating:",
		certificateLabel: "Certificate:",
		certificateInfoTooltip: "More information about the certificate",
		noCoating: "None",
		materialDivers: "Material: Various",
		additionalDesignationGrinded: " / Ground / Film",
		additionalDesignationAnodized: " / Film",
		additionalDesignationRibbed: " / Ribbed",
	},
	assembly: {
		moreText: "more...",
		showSubarticlesButton: "Show individual articles",
		showSubarticlesTooltip: "Shows all articles of this assembly.",
		calculatingMessage: "Some articles in this assembly are currently being calculated.",
		noValidBodies:
			"The assembly does not contain any valid solids. The solids may be open or defined only as surfaces.",
		checkSubarticlesHint:
			"Click on 'Show individual articles' to see the status of the individual articles and carry out any required actions on them.",
	},
	state: {
		errorHint:
			"Open the article in CAD and check the error, or send it to our helpdesk for a free assessment.",
		infoHint:
			"Please open the article in CAD and define what should be done with the detected treatments.",
		inReview: "Under review",
		ok: "OK",
		warning: "Warning",
		error: "Error",
		new: "New",
		actionRequired: "Action required",
		unclear: "Unclear",
	},
	cart: {
		quantityPlaceholder: "Quantity",
		addToCartButton: "Add to cart",
		addToCartTooltip: "Adds the article to the cart.",
		addedToCartSnackbar: "{quantity} pcs added to cart.",
		assemblyPartCannotOrder:
			"Articles that are part of an assembly cannot be ordered individually.",
		powderCoatingEngravingConflictLine1:
			"Articles with powder coating and engraving cannot be ordered.",
		powderCoatingEngravingConflictLine2:
			"The engraving would be completely covered by the powder coating.",
		powderCoatingEngravingConflictLine3:
			"Remove either the engraving or the powder coating so the article can be ordered.",
		cannotBeProducedInRegion: "The article currently cannot be ordered in {region}.",
	},
	buttons: {
		openCad: "View / edit CAD model",
		sendToHelpdesk: "Send to helpdesk",
		sendToHelpdeskTooltipLine1: "The article is sent to our helpdesk and analysed free of charge.",
		sendToHelpdeskTooltipLine2: "You will be notified as soon as we have processed your article.",
		blexonize: "Blexonise article",
		blexonizeTooltipLine1: "The article has not yet been blexonised with the latest version.",
		blexonizeTooltipLine2:
			"To order the article, check it or change it in CAD, please click here.",
	},
	messages: {
		checkCartMembershipError:
			"It is currently not possible to check whether the article is used in a bill of materials.",
	},
	header: {
		selectForMultiActionTooltip: "Select for multi-action. Possible actions are shown above.",
		contextMenuTooltip: "Opens the context menu for the article.",
		edit: "Edit",
		delete: "Delete",
		unlock: "Unlock",
		lock: "Lock",
	},
	pricelist: {
		openTooltip: "Opens the article's price list.",
		button: "Price list",
		pricesNotCalculatedLine1: "The prices for this article could not be calculated.",
		pricesNotCalculatedLine2: "Please send the article to our helpdesk for a free assessment.",
		priceInfoTooltip: "Find out here how to get your articles even cheaper.",
		priceHintLabel: "Price note",
		pricePerUnitMulti: "Price / pc. [{currency}]",
		pricePerUnitSingle: "Price/pc. [{currency}]",
		quantityLabel: "Quantity",
		fromQuantity: "from {quantity}",
		addQuantityToCartTooltip: "{quantity} pcs to cart",
		hintTitle: "You will see the final price including the volume discount in the cart.",
		hintText:
			"Several articles with the same treatments or the same material lead to a price reduction. To calculate the final price, please put together a cart and get a quote including the delivery date calculated within seconds.",
		loadError: "Prices for the article could not be loaded.",
	},
};
